module.exports = __webpack_public_path__ + "img/u12442.6be37ccf.png";